import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom'
import { Radio, Input, DatePicker, Select, Switch, Button, Form, Checkbox, Tooltip } from 'antd';
import Card, { TitleCard, CardHeader } from '../../core/Card'
import { FromToIcon, PlusIcon, CrownIcon, BriefcaseIcon, MarkerIcon, ForwardIcon, HomeIcon, DotIcon } from '../../core/icons'
import { updateUser } from '../actions'
import onMount from '../../core/onMount'
import { reduxForm, hasSubmitSucceeded, hasSubmitFailed, Field, submit } from 'redux-form'
import { connect } from 'react-redux'
import './Tracker.css'
import makeField from '../makeField'

const SwitchWithTooltip = (props)=>
  <Tooltip title={'This can only be changed from within the app'} placement='right'>
    <span>
      <Switch {...props}/>
    </span>
  </Tooltip>
const ASwitch = makeField(SwitchWithTooltip)
const ASelect = makeField(Select)

const Tracker = ({purposes, handleSubmit, error, pristine, save, loading, submitted, submitting, onRemoteSubmit, auto_detect_enabled, auto_classify}) =>
  <div className="Tracker">

    <TitleCard>
      <h1>Tracker Settings</h1>
      <Button type="primary" loading={submitting} onClick={handleSubmit} disabled={pristine}>
        Save
      </Button>
    </TitleCard>

    <Card>
      <CardHeader
        title="Settings"
      />

      <div className="Options">

        <Field
          name="auto_detect_enabled"
          label="Automatic Detection"
          component={ASwitch}
          type="checkbox"
          disabled
        />

        <hr/>

        <Field name="auto_classify" component={ASelect} label="Auto Classify">
          {[...purposes, 'OFF'].map(o => (
            <option value={o} key={o}>{o}</option>
          ))}
        </Field>

        {error && <strong>{error}</strong>}

      </div>


    </Card>
  </div>

export const getPurposes = (state) => ["Work", "Personal", "Other", ...state.models.user.income_sources]

const mapStateToProps = ({models}) => {
  const { auto_detect_enabled, auto_classify } = models.user
  return {
    initialValues: {
      auto_detect_enabled,
      auto_classify
    },
    purposes: getPurposes({models}),
    enableReinitialize: true
  }
}

const TrackerForm = reduxForm({
  form: 'Tracker',  // a unique identifier for this form
  // You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop if remote subission
  onSubmit: (values, dispatch)=> dispatch(updateUser(values)),
})(Tracker)

export default connect(mapStateToProps)(TrackerForm)



// WEBPACK FOOTER //
// ./src/account/tracker/Tracker.js